//TODO: Вынести из модулей код такой же код как ниже и переиспользовать тут
export function getSourceGroupId(group) {
  if (group.type === 'DynamicBaseGroupNode') {
    return group.sourceGroupId;
  } else if (group.type === 'DynamicGeneratedGroupNode' && group.source) {
    return group.source.id;
  }

  return group.id;
}